<div class="card card-lg p-2 p-sm-4 px-lg-5 px-xl-6" scAnchorTarget="book">

	<div class="card-body" #scrollCta>  
  
	  <div class="row">
  
		<div class="col-12 col-lg-8">
  
		  <h2 class="heading-serif heading-lg mb-4">Buche jetzt deine Demo</h2>
  
		  <p class="lead">
			Erlebe unsere KI live – auf Basis einer echten Stellenausschreibung deines Unternehmens. Kein Standard-Pitch, sondern ein praxisnaher Einblick in Funktionen, Matching-Logik und Ergebnisse. Buche jetzt deinen individuellen Termin.
		  </p>
		  
  
		  <a class="btn btn-primary btn-lg btn-round mt-4" (click)="goToBooking()">Jetzt buchen</a>
  
		</div>
  
	  </div>
  
	</div>
  
  </div>
  